import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { useExperiment } from '@sm/webassets';
import { NavRouteParams } from '~pricing/components/Navigation/types';

import BackToSummary from '~pricing/components/BackToSummary';
import MainHeading from '~pricing/components/MainHeading';
import Navigation from '~pricing/components/Navigation';
import DetailsFooter from '~pricing/components/PricingFooter';
import useTrackingDetails from '~pricing/hooks/useTrackingDetails';
import COPY from '~app/pages/Pricing/copy';
import DetailsPackagesView from '~pricing/components/DetailsPackagesView';
import { usePricingState } from '~shared/hooks/usePricingState';
import DiscountBanner from '~pricing/components/DiscountBanner';
import { ROOT_PRICING_ROUTE } from '~shared/constants/pricing';
/**
 *  This only gets generated on the details page. If canonical path is missing then,
 *  we must be on the /pricing/details (canonical to details), the back link should default to teams summary
 *  with ut_source attached as per legacy billweb
 */

export default function PricingDetailsPage(): JSX.Element {
  const { canonicalPath } = useParams<NavRouteParams>();

  const {
    state: {
      packages: { allPackages, discountInfo, displayPackages },
    },
  } = usePricingState();
  const { pageUtSource } = useTrackingDetails();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { treatments: discountBannerTreatments } = useExperiment({
    name: 'billing_20014_teams_discount',
    treatmentNames: ['billing_20014_teams_discount_control', 'billing_20014_teams_discount_treatment'],
  });

  const showDiscountBanner = discountBannerTreatments?.billing_20014_teams_discount_treatment?.treatmentName;

  return (
    <div key="PricingDetails">
      <header>
        <BackToSummary
          url={createURL(`${ROOT_PRICING_ROUTE}/${canonicalPath || 'teams'}`, { ut_source: pageUtSource })}
        />
        {showDiscountBanner && <DiscountBanner />}
        <MainHeading>{t(COPY.DETAILS_HEADING)}</MainHeading>
        <Navigation />
      </header>
      <DetailsPackagesView
        packageData={displayPackages}
        discountInfo={discountInfo}
        key={`${canonicalPath}-${displayPackages.length}`}
      />
      <DetailsFooter packages={allPackages} />
    </div>
  );
}
